import { useQuery } from '@tanstack/react-query'
import { fetchData } from '../../api/fetchJson'
import { orgPath } from '../../config/orgId'

export type Project = {
  id: string
  name: string
  status?: string
  primary_site_lead_name?: string
  description?: string | null
  start_date?: number | null
  end_date?: number | null
  target_end_date?: number | null
  location?: string | null
  address?: string | null
  client_name?: string | null
  code?: string | null
}

type ProjectDetailEnvelope = {
  project: Project
  stats?: Record<string, number | null>
}

export function useProject(projectId: string | undefined) {
  return useQuery<Project>({
    queryKey: ['project', projectId],
    enabled: Boolean(projectId),
    queryFn: async () => {
      const env = await fetchData<ProjectDetailEnvelope>(
        orgPath(`/projects/${projectId}`),
      )
      return env.project
    },
  })
}

export type ProjectDashboard = {
  totals?: Record<string, number>
  recent_activity?: Array<{ id: string; description: string; created_at: number }>
  [k: string]: unknown
}

export function useProjectDashboard(projectId: string | undefined) {
  return useQuery<ProjectDashboard>({
    queryKey: ['project-dashboard', projectId],
    enabled: Boolean(projectId),
    queryFn: () =>
      fetchData<ProjectDashboard>(orgPath(`/dashboard/projects/${projectId}`)),
  })
}
